"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("../utils/styled"));
const utils_1 = require("../utils");
const Container = styled_1.default("div")(({ dragActive, theme }) => (Object.assign({ width: 400, height: 108, textAlign: "center", alignItems: "center", display: "flex", flexDirection: "column", justifyContent: "center" }, (dragActive
    ? {
        backgroundColor: utils_1.setAlpha(0.05)(theme.color.primary),
        border: `1px solid ${theme.color.primary}`,
        color: theme.color.primary,
    }
    : {
        backgroundColor: theme.color.background.lightest,
        border: `1px dashed ${theme.color.border.default}`,
    }))));
const Uploader = (_a) => {
    var { dragActive } = _a, props = __rest(_a, ["dragActive"]);
    return (React.createElement(Container, Object.assign({}, props, { dragActive: dragActive }), props.children));
};
exports.default = Uploader;
//# sourceMappingURL=Uploader.js.map